import { ServiceMaker, methods, services } from "@/services";

export const customerOpenServiceTicket = () =>
  ServiceMaker(`/servicerequest/ticket/list`, methods.GET, services.master);

export const updateCustomerServiceTicket = payload =>
  ServiceMaker(
    `/servicerequest/ticket/update/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

export const postCommentCustomerServiceTicket = payload =>
  ServiceMaker(
    `/servicerequest/ticket/postcomment/${payload.id}`,
    methods.POST,
    services.master,
    payload.data
  );
